<template>
  <list-table
    url="accdocdetail"
    title="لیست گردش حساب"
    detailUrl="editDocument"
    newUrl="newDocument"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../../components/table";
export default {
  name: "DocTransactions",
  components: {
    "list-table": TableShowData,
  },
  data() {
    return {
      fields: [
        {
          key: "detail.code",
          label: "کد تفضیلی",
        },
        {
          key: "des",
          label: "توضیحات",
        },
        {
          key: "bed",
          label: "بدهکار",
        },
        {
          key: "bes",
          label: "بستانکار",
        }
      ],
      params: [
        {
          label: "شماره تفضیلی",
          field: "detailed_id",
          type: "text",
        }
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست گردش حساب" }]);
  },
};
</script>